<template>
    <v-row align="center">
        <v-list-item-avatar class="tw-ml-2">
            <img
                :src="getCardIcon(paymentMethod.brand)"
                data-testid="card-icon"
            />
        </v-list-item-avatar>

        <v-list-item-content>
            <v-list-item-title
                class="text-wrap"
                data-testid="card-brand-and-last4"
                >{{ paymentMethod.brand.toUpperCase() }} ....{{
                    paymentMethod.last4
                }}</v-list-item-title
            >
            <v-list-item-subtitle
                class="text-wrap"
                data-testid="card-expiration"
                >{{ $t('message.expiration') }}: {{ paymentMethod.expMonth }}/{{
                    paymentMethod.expYear
                }}</v-list-item-subtitle
            >
        </v-list-item-content>

        <slot name="actions"></slot>
    </v-row>
</template>

<script setup>
import visa from '@/assets/icons/creditcards/logo/visa.svg'
import mastercard from '@/assets/icons/creditcards/logo/mastercard.svg'
import amex from '@/assets/icons/creditcards/logo/amex.svg'
import discover from '@/assets/icons/creditcards/logo/discover.svg'
import alipay from '@/assets/icons/creditcards/logo/alipay.svg'
import unionpay from '@/assets/icons/creditcards/logo/unionpay.svg'
import generic from '@/assets/icons/creditcards/logo/generic.svg'

const props = defineProps({
    paymentMethod: {
        type: Object,
        default: () => ({}),
    },
})

const getCardIcon = (brand) => {
    switch (brand.toLowerCase()) {
        case 'visa':
            return visa
        case 'mastercard':
            return mastercard
        case 'amex':
            return amex
        case 'discover':
            return discover
        case 'alipay':
            return alipay
        case 'unionpay':
            return unionpay
        default:
            return generic
    }
}
</script>
